import { render, staticRenderFns } from "./BigFadeInText.vue?vue&type=template&id=2dde4610&scoped=true&"
import script from "./BigFadeInText.vue?vue&type=script&lang=js&"
export * from "./BigFadeInText.vue?vue&type=script&lang=js&"
import style0 from "./BigFadeInText.vue?vue&type=style&index=0&id=2dde4610&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dde4610",
  null
  
)

export default component.exports